import React, { Component, Fragment } from 'react';
import { Grid } from "@mui/material";
import DrawerCustom from '../../components/CustomDrawer';
import CustomizedCircularProgress from '../../components/CustomCircularProgress';
class AddCardView extends Component {
  componentDidUpdate() {
    let paymentForm = document.forms['paymentForm'];
    if(paymentForm){
      paymentForm.submit()
    }
  }
    render() {
        const { onCloseAddCard, html_content } = this.props
        return (
            <div>
                <DrawerCustom
                    open={this.props.open}
                    onClose={() => onCloseAddCard()}
                    title={"Add Card"}
                    enableBack
                >   
                    <div style={{width:'100%'}} dangerouslySetInnerHTML={{__html:html_content}}/>
                    <Grid xs={12} item container justify='center'><CustomizedCircularProgress/></Grid>
                </DrawerCustom>
            </div>
        );
    }
}
export default AddCardView;